import * as React from 'react';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export function DemoUserBanner(): React.ReactElement {
  const classes = useStyles();

  return (
    <div data-testid="demo-user-banner" className={classes.banner}>
      You are in a demo account. You can only use this account once.&nbsp;
      <a href="/auth/test-account" className={classes.link}>
        Create a new demo account.
      </a>
    </div>
  );
}

const useStyles = makeStyles({
  banner: {
    backgroundColor: tokens.colorPaletteGreenBackground3,
    color: tokens.colorStrokeFocus1,
    ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalS),
  },
  link: {
    color: tokens.colorStrokeFocus1,
    textDecorationLine: 'underline',
  },
});
